import {BasicSymbolType} from "../../../core/reel/symbol/config/IReelSymbolStruct";
import {ArrayHelper} from "../../../core/utils/ArrayHelper";
import {Helper} from "../../../core/utils/Helper";
import {GameConfig} from "../../config/base/GameConfig";
import {IWinRatioConfig} from "../../config/base/IWinConfig";
import {IAllWinData, IWinData} from "../base/IData";
import {CoreData} from "./CoreData";

export class ReelGameData extends CoreData {
    protected _reelsNextSpin: string;
    protected _currentWindowReels: string[][] = [];

    public get evaldata(): string[][] {
        return Helper.fetchOrApply(this.data.evaluatedArea, []) as string[][];
    }

    public get SoulWildPositions(): number[][] {
        return this.findMultSymbol(["SW1", "SW2", "SW3"], this.evaldata) as number[][];
    }

    public get amountOfSoulWilds(): number {
        return ArrayHelper.countAmountOfIndexes(this.SoulWildPositions);
    }

    private filterReelToWindowReels(size: number[]): string[][] {
        return this.reels.map((r, reel) =>
            r
                .map((w, row) => {
                    if (row == 0 || size[reel] < row) return "";
                    return w;
                })
                .filter((v) => !!v)
        );
    }

    public get windowReel(): string[][] {
        return this._currentWindowReels;
    }

    public get reels(): string[][] {
        return this.data.reels;
    }

    public get reelsNextSpin(): string {
        return (this._reelsNextSpin = Helper.fetchOrApply(this.data.nextMode, this.data.mode));
    }

    public get amountOfScattersLanded(): number {
        return ArrayHelper.countWithCondition(this.scatterPositions, (v) => v >= 0);
    }

    public get scatterHaveLanded(): boolean {
        return !!this.amountOfScattersLanded;
    }

    public get swPositions(): number[] {
        return this.fetchSymbolPos(BasicSymbolType.SW, this.windowReel, true) as number[];
    }

    public get scatterPositions(): number[] {
        return this.fetchSymbolPos(BasicSymbolType.SCATTER, this.windowReel, true) as number[];
    }

    public get mysteryPos(): number[] {
        return this.fetchSymbolPos(BasicSymbolType.MYSTERY, this.windowReel, true) as number[];
    }

    public get wildSinglePos(): number[] {
        return this.fetchSymbolPos(BasicSymbolType.WILD, this.windowReel, true) as number[];
    }

    public get gotMystery(): boolean {
        return !!this.mysteryPos.filter((v) => v >= 0).length;
    }

    public get WildPositions(): number[][] {
        return this.fetchSymbolPos(BasicSymbolType.WILD, this.data.evaluatedArea, false) as number[][];
    }

    public get amountOfScatters(): number {
        return this.totalAmountOfType(BasicSymbolType.SCATTER, this.windowReel);
    }

    public get symbolSizeMap(): number[][] {
        return Helper.fetchOrApply(this.symbolSizes, ArrayHelper.countAmountOfIndexes(this.windowReel));
    }

    public get totalPossibleWays(): number {
        return Helper.fetchOrApply(this.data.totalWays, 1);
    }

    public get symbolSizes(): number[][] {
        return Helper.fetchOrApply(this.data.symbolSizes, [[]]);
    }

    public get fetchTopLeftSWPosition(): {reel:number,row:number} {
        let pos = { reel:-1, row:-1};
        
        const temp = this.SWBoolMap;
        for(let reel = 0; reel < temp.length;reel++){
            if(pos.reel != -1) break;
            for(let row = 0; row < temp[reel].length;row++){
                if(pos.reel != -1) break;
                if(temp[reel][row]){
                    pos.reel = reel;
                    pos.row = row;
                } 
            }
        }

        return pos;
    }

    public get SWBoolMap(): boolean[][] {
        return this.symbolBooleanPos("SW", this.evaldata );
    }

    public get scatterBoolMap(): boolean[][] {
        return this.symbolBooleanPos(BasicSymbolType.SCATTER, this.reels );
    }

    public get ammScatterCaught():number {
        let temp = 0;
        const scatBoolM = this.scatterBoolMap;
        const swBoolM = this.SWBoolMap;
        ArrayHelper.eachForEach(swBoolM,(reel,row,val) => {
            if(swBoolM[reel][row] && scatBoolM[reel][row]) temp++;
        })
        return temp;
    }

    public get SWSize(): number {
        const temp = this.SWBoolMap;
        let count = 0;
        temp.forEach(arr => { count += ArrayHelper.countWithCondition(arr, (v) => v);})
        return count > 4 ? 3 : (count == 4 ? 2 : count);
    }


    public get wildBoolMap(): boolean[][] {
        return this.symbolBooleanPos(BasicSymbolType.WILD, this.data.evaluatedArea);
    }

    public get reelModeHeight(): number {
        return Math.max(this.symbolSizes[0].length, 3);
    }

    public get gameAreaSize(): number[] {
        return Helper.fetchOrApply(
            ArrayHelper.initArrayWithValues(this.data.reels.length, (i) => this.reelModeHeight),
            []
        );
    }

    apply(data: any): void {
        super.apply(data);
        // this._currentWindowReels = this.filterReelToWindowReels(this.gameAreaSize);
    }
}

export class WinGameData extends CoreData {
    private _winData: IWinData[] = [];
    private _allBetWayWinData: IAllWinData;

    public get totalWinCombination(): number {
        return Helper.fetchOrApply(this.allBetWayWinData.totalWinCombination, 0);
    }

    public get brokeTheBank(): boolean {
        return Helper.fetchOrApply(this.data.brokeTheBank, false);
    }

    public get totalWin(): number {
        return Helper.fetchOrApply(this.data.accumulatedRoundWin, 0);
    }

    public get singleWin(): number {
        return Helper.fetchOrApply(this.data.thisSpinWinning, 0);

    }
    public get totalSpinWin(): number {
        return Helper.fetchOrApply(this.data.totalSpinWinnings, 0);

    }

    public get playedBetValue(): number {
        return Helper.fetchOrApply(this.data.playedBetValue, 0);
    }

    public get winData(): IWinData[] {
        return this._winData;
    }

    public get allBetWayWinData(): IAllWinData {
        return this._allBetWayWinData;
    }

    public get winRatio(): number {
        return this.singleWin / this.playedBetValue;
    }

    public get evalSize(): number {
        return Helper.fetchOrApply(this.data.evaluatedArea ? this.data.evaluatedArea[0].length : 3, 3);
    }

    public get totalWinRatio(): number {
        return this.totalWin / this.playedBetValue;
    }

    public get isBigWin(): boolean {
        return this.winRatio*.9 > (this.data.currentLevel === 5 ? GameConfig.WIN_RATIOS.SFSBigWin[0].ratio : GameConfig.WIN_RATIOS.bigWin[0].ratio);
    }

    public get winRatioConfig(): IWinRatioConfig {
        return this.getWinRatioConfig(
            this.winRatio,
            GameConfig.WIN_RATIOS.normalWin.concat()
        );
    }

    apply(data: any): void {
        super.apply(data);

        this._winData = this.data.evaluatedArea
            ? this.addBetLvls(
                this.createConnectedWinWays(this.data.betWayWins, this.data.evaluatedArea),
                this.playedBetValue,
                GameConfig.WIN_RATIOS!.normalWin
            )
            : [];
        this._winData.sort((a, b) => b.amount - a.amount);
        this._allBetWayWinData = this.parseAllHits(this._winData, this.data.reels.length, this.evalSize);
        if (this._winData && this._winData.length > 1) {
            this._winData = this.mergeSameSymbolData(this._winData);
        }
    }

    protected mergeSameSymbolData(data: IWinData[]) {
        let winGroupData: IWinData[] = [];
        data.forEach((winData: IWinData) => {
            let previousData: any = null;
            winGroupData.forEach((winGroup: IWinData) => {
                if (winGroup.symbol === winData.symbol) {
                    previousData = winGroup;
                }
            });
            if (previousData) {
                previousData.reelWinPositions.forEach((reelValue: boolean[], reelId: number) => {
                    reelValue.forEach((isWin: boolean, symId: number) => {
                        if (isWin || winData.reelWinPositions[reelId][symId]) {
                            previousData.reelWinPositions[reelId][symId] = true;
                        }
                    });
                });
                previousData.length = (previousData.length > winData!.length) ? previousData.length : winData?.length;
                previousData.amount = previousData.amount + winData.amount;
                previousData.numberOfCombinations = previousData.numberOfCombinations + winData.numberOfCombinations;
                previousData.multipliedAmount = previousData.multipliedAmount + winData.multipliedAmount;
            } else {
                winGroupData.push(winData);
            }
        });
        return winGroupData;
    }
}
